import React from "react";
import "./loadingStep.scss";

const LoadingStep = () => {
  return (
    <div className="container">
      <div className="spinner" />
    </div>
  );
};

export default LoadingStep;
